import { getRooftopId } from 'selectors/appStatusSelectors'
import { getIsLoggedIn, hasWrite } from 'selectors/authSelectors'
import { getLandingRoute, withRooftop } from 'pages/routes'

// Wires store state into the landing policy in pages/routes. Everything that
// means "take me to this rooftop's home" reads one of these — never a route
// literal — so the policy has exactly one place to change.
//
// Safe to call as soon as the app renders routes: `loginChecked` is dispatched
// after userData lands (see updateAuth), and the app holds a loading screen
// until then, so permissions are settled before anyone asks.
export const getLandingRoutePattern = state =>
    getLandingRoute({
      isLoggedIn: Boolean(getIsLoggedIn(state)),
      can: permission => hasWrite(state, permission),
    }),
  getLandingRouteUrl = state =>
    withRooftop(getLandingRoutePattern(state), getRooftopId(state))
